module.exports = __webpack_public_path__ + "static/media/facturas.ef981404.svg";